
<div class="row">

  <div class="lower-action-row">
    <div class="col-24">
        <ng-content></ng-content>
    </div>
  </div>

</div>
